import * as e from "react";
import { forwardRef as o } from "react";
const n = o(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 19 16",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("path", { d: "M15.7554 16H0L2.7604 0H18.5158L15.7554 16Z", fill: "#00FFB7" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.4891 6.7257H10.7699L11.2014 4.21049L8.84843 2.94071L8.19328 6.7257H5.71652L4.01474 9.34234H7.74587L7.31044 11.8494L9.66736 13.1192L10.3185 9.34234H12.7873L14.4891 6.7257Z",
        fill: "#000"
      }
    )
  );
});
export {
  n as Rab
};
